import { Injectable, Inject } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormELReclassification } from "../Models/Forms/IFormELReclassification";
import { BaseService } from './BaseService';

@Injectable()
export class FormELReclassificationService  extends  BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string)
  {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormELReclassification(id: number) {
    return this._http.get(this._baseUrl + "api/FormELReclassification/" + id)
      .map((response: IFormELReclassification) => response as IFormELReclassification)
      .catch(this.errorHandler);
  }

  insertUpdateFormELReclassification(formELReclassificationDetails: IFormELReclassification) {
    return this._http.post(this._baseUrl + 'api/FormELReclassification', formELReclassificationDetails)
      .map((response: IFormELReclassification) => response as IFormELReclassification)
      .catch(this.errorHandler);
  }

  deleteELReclassification(id) {
    return this._http.delete(this._baseUrl + "api/FormELReclassification" + id)
      .map((response: IFormELReclassification) => response as IFormELReclassification)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
  
}


